import React from 'react';
import { Star, Shield, Award } from 'lucide-react';

/**
 * ReviewBadges — visual social proof for the hero.
 * Includes 1 review platform (Google) + 2 credential badges (Licensed + Warranty).
 *
 * To add more review platforms later (Yelp, BBB, Houzz), add them to the badges array.
 */
const ReviewBadges = () => {
  return (
    <div className="flex items-center gap-3 sm:gap-4 flex-wrap justify-center">
      {/* Google Reviews — real review platform with live link */}
      <a
        href="https://g.page/r/CS9tqGDQygtDEBM/review"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow-md border-2 border-gray-200 hover:border-brand-gold hover:shadow-xl hover:scale-105 transition-all"
        data-testid="review-badge-google"
        title="See our Google Reviews"
      >
        <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
          G
        </div>
        <div className="flex flex-col items-start">
          <div className="flex items-center gap-0.5">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} className="w-3 h-3 fill-brand-gold text-brand-gold" />
            ))}
          </div>
          <span className="text-xs font-bold text-gray-900 leading-tight">
            5.0 on Google
          </span>
        </div>
      </a>

      {/* Licensed & Insured — credential badge */}
      <div
        className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow-md border-2 border-gray-200"
        data-testid="review-badge-licensed"
      >
        <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white flex-shrink-0">
          <Shield className="w-4 h-4" />
        </div>
        <div className="flex flex-col items-start">
          <span className="text-[10px] font-medium text-gray-700 leading-none">Florida</span>
          <span className="text-xs font-bold text-gray-900 leading-tight">
            Licensed & Insured
          </span>
        </div>
      </div>

      {/* Lifetime Warranty — credential badge */}
      <div
        className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow-md border-2 border-gray-200"
        data-testid="review-badge-warranty"
      >
        <div className="w-8 h-8 rounded-full bg-brand-gold flex items-center justify-center text-brand-black flex-shrink-0">
          <Award className="w-4 h-4" />
        </div>
        <div className="flex flex-col items-start">
          <span className="text-[10px] font-medium text-gray-700 leading-none">Industry-Leading</span>
          <span className="text-xs font-bold text-gray-900 leading-tight">
            Lifetime Warranty
          </span>
        </div>
      </div>
    </div>
  );
};

export default ReviewBadges;
